import styled from 'styled-components'

import ActionButton from '../ActionButton'

export const Container = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  bottom: ${({ $isVisible }) => ($isVisible ? '0' : '-100%')};
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ theme }) => theme.colors.greenEmerald};
  z-index: 100;
  border-top-left-radius: 3rem;
  border-top-right-radius: 3rem;

  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 45rem;
  max-width: 100%;
  padding: 1rem 2rem;
  box-shadow: 0 -2px 15px rgb(0 0 0 / 20%);
  transition: bottom 0.3s;
  @media print {
    display: none;
  }
`

export const Text = styled.p`
  font-weight: 600;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.pureWhite};
`

export const Close = styled(ActionButton)`
  display: flex;
  align-items: center;
  & button {
    width: 3.5rem;
    height: 3.2rem;
    background-color: transparent;
    border: none;
    box-shadow: none;
    border-radius: 50%;
  }
  & span {
    width: 1.2rem;
    height: 1.2rem;
    color: ${({ theme }) => theme.colors.pureWhite};
  }
  transition: 0.15s;
  transition-property: border, background-color, color;
  transition-timing-function: ease-in-out;

  &:hover {
    & button {
      background-color: ${({ theme }) => theme.colors.pureWhite} !important;
      border: 1px solid ${({ theme }) => theme.colors.pureWhite} !important;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    }
    & span {
      width: 1.2rem;
      height: 1.2rem;
      color: ${({ theme }) => theme.colors.pureBlack};
    }
  }
`
